import cbnews from './assets/cbnews.svg';
import challenges from './assets/challenges.svg';
import coinspeaker from './assets/coinspeaker.svg';
import lesechos from './assets/lesechos.svg';
import lopinion from './assets/lopinion.svg';
import sbb from './assets/sbb.webp';

export const articles = [
  {
    name: 'Les Echos',
    svgUrl: lesechos,
    href: 'https://www.lesechos.fr/start-up/deals/foot-a-la-relance-la-start-up-sorare-signe-avec-la-lfp-2182592',
  },
  {
    name: "L'Opinion",
    svgUrl: lopinion,
    href: 'https://www.lopinion.fr/economie/oser-en-2025-liberer-le-potentiel-du-web3-par-nicolas-julia',
  },
  {
    name: 'Cbnews',
    svgUrl: cbnews,
    href: 'https://www.cbnews.fr/marques/image-qui-veut-remplacer-kylian-mbappe-sorare-86928',
  },
  {
    name: 'Coinspeaker',
    svgUrl: coinspeaker,
    href: 'https://www.coinspeaker.com/sorare-moves-to-solana-to-upgrade-its-on-chain-fantasy-sports-platform/',
  },
  {
    name: 'Sport Buzz Business',
    svgUrl: sbb,
    href: 'https://www.sportbuzzbusiness.fr/sorare-prolonge-son-partenariat-avec-la-nba-et-la-nbpa.html',
  },
  {
    name: 'Challenges',
    svgUrl: challenges,
    href: 'https://www.challenges.fr/economie/l-incroyable-levee-580-m-de-sorare-startup-francaise-de-cartes-a-jouer_781417',
  },
];
